module.exports = __webpack_public_path__ + "img/open-box.442c9245.svg";